var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"pay-loading"},[_c('loading',{attrs:{"box-size":14,"round-size":3,"color":'#3d81ff'}})],1),_c('div',{staticClass:"txt"},[_vm._v("考试列表加载中... ")])])}
var staticRenderFns = []

export { render, staticRenderFns }